module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bsILd"))).then(() => parcelRequire('iDabs'));